import clsx from 'clsx'

import {
    Button,
    HEADING_3_STYLES,
    LABEL_STYLES,
    LinkButton,
    PARAGRAPH_SMALL_STYLES,
} from 'src/libs/design-system'
import { Appear } from 'src/libs/react-utils'

import { Plan } from './types'

interface PricingPlanCardsProps<PlanKey extends string> {
    plans: [Plan<PlanKey>, Plan<PlanKey>, Plan<PlanKey>]
}

export function PricingPlanCards<PlanKey extends string>({
    plans,
}: PricingPlanCardsProps<PlanKey>) {
    return (
        <div className="grid gap-6 grid-cols-1 lg:grid-cols-3">
            {plans.map(
                ({
                    isMostPopular,
                    key,
                    title,
                    price,
                    priceDescription,
                    description,
                    ctaButton,
                    planTrial,
                }) => {
                    const sharedCtaProps = {
                        variant: 'primary',
                        size: 'large',
                        onClick: ctaButton.onClick,
                        className: isMostPopular
                            ? undefined
                            : /*tw:*/ 'bg-grey-700 hover:bg-grey-700/90 hover:animate-none focus-visible:animate-none',

                        children: ctaButton.label,
                    } as const

                    return (
                        <Appear
                            key={key}
                            className={clsx(
                                PARAGRAPH_SMALL_STYLES,
                                'rounded-3xl px-8 pt-6 pb-8',
                                isMostPopular ? 'bg-yellow-50' : 'bg-blue-100'
                            )}
                        >
                            <article className="grid gap-6 grid-rows-[auto,auto,minmax(0,1fr)] h-full">
                                <div className="min-h-[1.56rem]">
                                    {isMostPopular && (
                                        <span
                                            className={clsx(
                                                LABEL_STYLES,
                                                'bg-yellow-300 text-white rounded-lg inline-block px-[0.4rem] py-[0.3rem]'
                                            )}
                                        >
                                            30-DAY FREE TRIAL
                                        </span>
                                    )}
                                </div>
                                <div className="min-h-[5.65rem]">
                                    <h2 className="font-bold">{title}</h2>
                                    <p className={clsx(HEADING_3_STYLES, 'pt-1')}>{price}</p>
                                    {priceDescription && (
                                        <p className="text-grey-700/60">{priceDescription}</p>
                                    )}
                                </div>
                                <p>{description}</p>
                                <div>
                                    {ctaButton.href ? (
                                        // eslint-disable-next-line jsx-a11y/anchor-has-content
                                        <LinkButton href={ctaButton.href} {...sharedCtaProps} />
                                    ) : (
                                        <Button {...sharedCtaProps} />
                                    )}
                                </div>
                            </article>
                        </Appear>
                    )
                }
            )}
        </div>
    )
}
